import React from 'react';
import IncomingRequests from './IncomingRequests/Index';

interface RecruiterIncomingRequestsProps {
  id: number;
  name: string;
  sub_title: string;
  email?: string;
  icon?: string;
  score?: number;
  culture_score?: number;
  date: string;
  responded_at?: string;
  industry?: any[];
  stage?: number;
  status: number;
  jobId?: number;
  candidateId?: number;
  hired_at?: string;
  handleOpenModal: (id: number, type: string) => void;
  handleCancel: (id: number) => void;
  handleAccept: (id: number) => void;
  handleDecline: (id: number) => void;
  jobTitle?: string;
}

const RecruiterIncomingRequests: React.FC<RecruiterIncomingRequestsProps> = (
  props
) => {
  const { handleOpenModal, handleAccept, handleDecline, ...rest } = props;
  return (
    <IncomingRequests
      {...rest}
      isCandidate={false}
      setOpen={handleOpenModal}
      acceptRequest={handleAccept}
      declineRequest={handleDecline}
    />
  );
};

export default RecruiterIncomingRequests;
